import { Container, Stack, Text, Title } from "@assetwatch/ui";

export function AppNotFoundContent() {
  return (
    <Stack gap={16}>
      <Title size="lg">Not found</Title>
      <Text tone="subtle">The requested New Modality page does not exist.</Text>
    </Stack>
  );
}

export function AppNotFound() {
  return (
    <Container size="sm">
      <AppNotFoundContent />
    </Container>
  );
}
